import React from 'react';

/** Shared Redact AI brand mark (document + scan badge). */
export const BrandLogoIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M11 2H33L41 10V46C41 48.2091 39.2091 50 37 50H11C8.79086 50 7 48.2091 7 46V6C7 3.79086 8.79086 2 11 2Z"
      fill="#E0F2FE"
      stroke="#1E40AF"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M33 2V10H41" stroke="#1E40AF" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M15 20H33" stroke="#1E40AF" strokeWidth="2.5" strokeLinecap="round" />
    <path d="M15 28H27" stroke="#1E40AF" strokeWidth="2.5" strokeLinecap="round" />
    <g>
      <rect x="22" y="30" width="26" height="26" rx="6" fill="#6EE7B7" />
      <circle cx="35" cy="43" r="8" stroke="white" strokeWidth="1.5" />
      <path d="M35 35V33" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M35 51V49" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M43 43H41" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M29 43H27" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M40.6569 37.3431L39.2426 38.7574" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M30.7574 47.2426L29.3431 48.6569" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M40.6569 48.6569L39.2426 47.2426" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M30.7574 38.7574L29.3431 37.3431" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
      <circle cx="35" cy="43" r="2.5" fill="white" />
    </g>
  </svg>
);
